import { render } from "./EduForm.vue?vue&type=template&id=31a78257"
import script from "./EduForm.vue?vue&type=script&lang=js"
export * from "./EduForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/amatra-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__